<script setup>
import Navbar from './components/NavBar.vue';
import Footer from './components/FooterPage.vue';
import ShowModal from './components/ShowModal.vue';
</script>

<template>
  <div>
    <navbar />
    <main class="pt-4 min-vh">
      <router-view></router-view>
    </main>
    <Footer />
    <ShowModal />
  </div>
</template>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: textfield;
}

.min-vh {
  min-height: 50vh !important;
}
</style>
